/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type UpdateTournamentAdminDto = {
  /**
   * 제목
   */
  title?: string;
  /**
   * 설명
   */
  description?: string;
  /**
   * 썸네일 URL
   */
  thumbnailUrl?: string;
  /**
   * 관리자 메모
   */
  adminMemo?: string;
  /**
   * 공개 여부 (크리에이터 설정)
   */
  isHidden?: boolean;
  /**
   * 전역 숨김 (어드민 제재)
   */
  isGlobalHidden?: boolean;
  /**
   * 수익창출
   */
  isRevenueActive?: boolean;
  /**
   * 공개 범위 (PUBLIC | FRIENDS)
   */
  visibility?: UpdateTournamentAdminDto.visibility;
};
export namespace UpdateTournamentAdminDto {
  /**
   * 공개 범위 (PUBLIC | FRIENDS)
   */
  export enum visibility {
    PUBLIC = "PUBLIC",
    FRIENDS = "FRIENDS",
  }
}
